import DialogTitle from '@mui/material/DialogTitle'
import { useTranslation } from 'react-i18next'
import React from 'react'

import CustomDialog from 'shared/components/CustomDialog'

import CooperationRejectedNotification from './components/CooperationRejectedNotification'
import ClientOrderCreatedNotification from './components/ClientOrderCreatedNotification'
import CooperationExpiredNotification from './components/CooperationExpiredNotification'
import ClientCartCreatedNotification from './components/ClientCartCreatedNotification'
import OversizeOrderNotification from './components/OversizeOrderNotification'
import CsvSummaryNotification from './components/CSVSummaryNotification'
import PaymentNotification from './components/PaymentNotification'
import DeleteNotification from './components/DeleteNotification'
import OrderNotification from './components/OrderNotification'
import { FormType, NotificationInfo } from '../../types'

interface Props {
   open: boolean
   type?: FormType
   handleClose: () => void
   modalInfo?: NotificationInfo
}

export default function Modal({ open, type, handleClose, modalInfo }: Props) {
   const { t } = useTranslation()

   function renderContent() {
      switch (type) {
         case 'CLIENT_FINISHED_ORDER':
            return (
               <OrderNotification
                  notificationLocationUuid={modalInfo?.locationUuid}
                  handleClose={handleClose}
                  modalInfo={modalInfo}
               />
            )
         case 'WAITING_FOR_PAYMENT':
            return <PaymentNotification handleClose={handleClose} modalInfo={modalInfo} />
         case 'DELETE':
            return <DeleteNotification handleClose={handleClose} notificationUuid={modalInfo?.notificationUuid} />
         case 'AUTO_CART_CREATED':
         case 'AUTO_CART_CREATION_FAILED':
            return (
               <CsvSummaryNotification
                  notificationLocationUuid={modalInfo?.locationUuid}
                  cartUuid={modalInfo?.cartUuid || ''}
                  handleClose={handleClose}
                  type={type || 'AUTO_CART_CREATED'}
                  message={modalInfo?.message || ''}
               />
            )
         case 'ORDER_CREATED':
         case 'ORDER_CREATION_FAILED':
            return (
               <OversizeOrderNotification
                  notificationLocationUuid={modalInfo?.locationUuid}
                  handleClose={handleClose}
                  orderType={type || 'ORDER_CREATED'}
                  cartUuid={modalInfo?.cartUuid}
               />
            )
         case 'CLIENT_REFLINK_CART_CREATED':
            return (
               <ClientCartCreatedNotification
                  handleClose={handleClose}
                  notificationLocationUuid={modalInfo?.locationUuid}
                  cartUuid={modalInfo?.cartUuid || ''}
                  cartName={modalInfo?.cartName || ''}
               />
            )
         case 'CLIENT_REFLINK_ORDER_CREATED':
            return (
               <ClientOrderCreatedNotification
                  notificationLocationUuid={modalInfo?.locationUuid}
                  orderUuid={modalInfo?.orderUuid || ''}
                  handleClose={handleClose}
               />
            )
         case 'COOPERATION_REJECTED_BY_WHOLESALE':
            return (
               <CooperationRejectedNotification
                  wholesaleName={modalInfo?.wholesaleName || ''}
                  handleClose={handleClose}
               />
            )
         case 'COOPERATION_REFLINK_EXPIRED':
            return (
               <CooperationExpiredNotification
                  wholesaleName={modalInfo?.wholesaleName || ''}
                  handleClose={handleClose}
               />
            )
         default:
            return null
      }
   }
   return (
      <CustomDialog
         isLoading={!open}
         open={open}
         onClose={handleClose}
         content={
            <>
               <DialogTitle>{t(`NOTIFICATIONS:${type}`)}</DialogTitle>
               {renderContent()}
            </>
         }
      />
   )
}
